export const ASSET_TEST_SERVICE = 'Asset Testing';
export const INCOME_TEST_SERVICE = 'Income Testing';
export const DISTRIBUTION_TEST_SERVICE = 'Distribution Testing';
export const PSQ_SERVICE = 'PSQ';
export const ARQC_SERVICE = 'ARQC';
export const LEASE_REVIEW_SERVICE = 'Lease Review';
